import type { QueryClient } from "@tanstack/react-query";
import { recordPerformedActionInCaches } from "web_myplann/Api/Portfolio/alertBoxesCacheUtils";
import type {
	AlertBoxActionEnum,
	AlertBoxActionStateEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const markAlertActionPerformed = (
	queryClient: QueryClient,
	contractId: number,
	action: AlertBoxActionEnum,
	state: AlertBoxActionStateEnum,
) => {
	recordPerformedActionInCaches(
		queryClient,
		contractId,
		(alert) =>
			alert.primaryAction === action || alert.secondaryAction === action,
		action,
		state,
	);
};
